import styled from "styled-components";

export const Page = styled.div`
  width: 219mm;
  height: 283mm;
  margin: 0 auto 25px auto;
  position: relative;
  background: #fff;
  box-shadow: 0 0 14px 0 #ccc;

  .page-number {
    position: absolute;
    top: 46px;
    right: 35px;
  }

  &.landscape {
    width: 283mm;
    height: 219mm;
  }

  @media print {
    margin-bottom: 0;
    box-shadow: none;
    height: 279mm;

    &.landscape {
      height: 215mm;
    }

    .page-number {
      right: 48px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Printable/style.js